import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import DeleteScheduleMenuItem from "layouts/Flow Designer/components/ExecutionsCalendar/components/DeleteSchedulteMenuItem";
import { pauseSchedule, resumeSchedule } from "redux/actions/flowDesigner/calendarActionCreator";
import useAllowScheduleActions from "hooks/useAllowScheduleActions";

const ScheduleMenu = ({
  item,
  user,
  setOpenSchedulerDialog,
  setSelectedEvent,
  setOpenShareScheduleDialog,
  setOpenUnshareScheduleDialog,
  flows
}) => {
  const [scheduleMenu, setScheduleMenu] = useState(null);
  const { t } = useTranslation("flowDesigner");
  const dispatch = useDispatch();
  const permissions = useAllowScheduleActions(item);

  const handleOpenScheduleMenu = (event) => {
    setScheduleMenu(event.currentTarget);
  };

  const handleCloseScheduleMenu = () => {
    setScheduleMenu(null);
  };

  const resumeEvent = () => {
    const status = item?.repeat === "not_repeat" ? "Active" : "Recurring";
    handleCloseScheduleMenu();
    dispatch(resumeSchedule(user?.stripeId, item?.id, status));
  };

  const pauseEvent = () => {
    handleCloseScheduleMenu();
    dispatch(pauseSchedule(user?.stripeId, item?.id));
  };

  const editEvent = () => {
    handleCloseScheduleMenu();
    setSelectedEvent(item);
    setOpenSchedulerDialog(true);
  };

  const shareEvent = () => {
    handleCloseScheduleMenu();
    setSelectedEvent(item);
    setOpenShareScheduleDialog(true);
  };

  const unshareEvent = () => {
    handleCloseScheduleMenu();
    setSelectedEvent(item);
    setOpenUnshareScheduleDialog(true);
  };

  return (
    <>
      {permissions.canOpenMenu && (
        <Tooltip title="More Actions" placement="top">
          <Icon fontSize="default" onClick={handleOpenScheduleMenu} sx={{ cursor: "pointer" }}>
            {"more_horiz_icon"}
          </Icon>
        </Tooltip>
      )}
      <Menu
        anchorEl={scheduleMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(scheduleMenu)}
        onClose={handleCloseScheduleMenu}
        keepMounted
      >
        {permissions.allowEdit && <MenuItem onClick={editEvent}>{t("menus.edit")}</MenuItem>}

        {permissions.allowShare && [
          <MenuItem key="share" onClick={shareEvent}>
            Share
          </MenuItem>,
          <MenuItem key="unshare" onClick={unshareEvent}>
            Unshare
          </MenuItem>
        ]}

        {permissions.allowPause &&
          (item?.status === "Paused" ? (
            <MenuItem onClick={resumeEvent}>Enable</MenuItem>
          ) : (
            <MenuItem onClick={pauseEvent}>Disable</MenuItem>
        ))}

        {permissions.allowDelete && (
          <DeleteScheduleMenuItem
            handleClose={handleCloseScheduleMenu}
            selectedEvent={item}
            isMenuItem
            flows={flows}
          />
        )}
      </Menu>
    </>
  );
};

export default ScheduleMenu;
